<template>
	<b-list-group flush>
		<b-list-group-item>
			<h4 class="float-left">{{drone.Name}}</h4>
			<p class="lead float-right">{{drone.Type}} {{drone.Level}}</p>
		</b-list-group-item>
		<div class="p-0">
			<div class="progress">
				<div class="progress-bar bg-danger" role="progressbar" :style="{width: percentage(current.Points.Hit, stats.HP)}">HP: {{current.Points.Hit}}/{{stats.HP}}</div>
			</div>
			<div class="progress" v-if="stats.RP">
				<div class="progress-bar bg-primary" role="progressbar" :style="{width: percentage(current.Points.Resolve, stats.HP)}">RP: {{current.Points.Resolve}}/{{stats.RP}}</div>
			</div>
		</div>
		<b-list-group-item class="p-1">
			<div class="row" style="padding-left: 15px!important; padding-right:15px!important;">
				<div class="col-12 col-sm-6 px-1">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text number">HP</span>
						</div>
						<input type="number" class="form-control" v-model.number="HP" min="0" :max="stats.HP">
						<div class="input-group-append">
							<span class="input-group-text">{{stats.HP}}</span>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 px-1" v-if="stats.RP">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text number">RP</span>
						</div>
						<input type="number" class="form-control" v-model.number="RP" min="0" :max="stats.RP">
						<div class="input-group-append">
							<span class="input-group-text">{{stats.RP}}</span>
						</div>
					</div>
				</div>
			</div>
		</b-list-group-item>
		<b-list-group-item>
			<span class="lead pr-2">Defense</span>
			<strong>EAC</strong> {{stats.AC + parseInt(drone.EAC)}}
			<strong>KAC</strong> {{stats.AC + parseInt(drone.KAC)}}
			<strong>Fort</strong> {{ (drone.GoodSave == "Fortitude" ? stats.GoodSave : stats.PoorSave)|bonus }}
			<strong>Ref</strong> {{ (drone.GoodSave == "Reflex" ? stats.GoodSave : stats.PoorSave)|bonus }}
			<strong>Will</strong> {{ (drone.GoodSave == "Will" ? stats.GoodSave : stats.PoorSave)|bonus }}
		</b-list-group-item>
		<b-list-group-item>
			<span class="lead pr-2">Offense</span>
			<strong>Speed</strong> {{drone.Speed}}
			<strong>Melee</strong> {{(abilityMod(drone.AbilityScores.Strength)+stats.BAB)|bonus}}
			<strong>Ranged</strong> {{(abilityMod(drone.AbilityScores.Dexterity)+stats.BAB)|bonus}}
		</b-list-group-item>
		<b-list-group-item>
			<span class="lead">Statistics</span>
			<div>
				<span v-for="(score,ability) in drone.AbilityScores" v-bind:key="ability">
					<strong>{{ability|abbr}}</strong> {{score}} ({{abilityMod(score)|bonus}})
				</span>
			</div>
			<div>
				<strong>Skills</strong> {{drone.Skills}}
			</div>
			<div>
				<strong class="pr-1">Mods</strong>
				<ul class="list-inline d-inline">
					<li class="list-inline-item" v-for="(mod, index) in drone.Mods" v-bind:key="'drone-mod-'+index">
						<a target="drone_mod" :href="'https://thehiddentruth.info/player/class/mechanic/drone/mod?page='+spellConcat(mod)">{{mod}}</a>
					</li>
				</ul>
			</div>
			<div>
				<strong class="pr-1">Feats</strong>
				<ul class="list-inline d-inline">
					<li class="list-inline-item" v-for="(feat, index) in drone.Feats" v-bind:key="'drone-feat-'+index">
						<a target="drone_feat" :href="'https://thehiddentruth.info/player/feats/?page='+spellConcat(feat)">{{feat}}</a>
					</li>
				</ul>
			</div>
		</b-list-group-item>
	</b-list-group>
</template>

<script>
export default {
	methods: {
		abilityMod: function(score) {
			return Math.floor((score - 10) / 2)
		},
		percentage: function(fraction, whole){
			return Math.round( (fraction/whole)*100 )+'%';
		},
		spellConcat: function(spell) {
			var name = spell.replace(/\(.*\)/, '').replace(/[^a-zA-Z-]+/g, '');
			return name;
		}
	},
	computed: {
		drone: function() {
			return this.$store.state.Character.Levels[ this.$store.getters['currentLevel'] ].Drone
		},
		current: function() {
			return this.$store.state.Character.Current.Drone
		},
		stats: function() {
			return this.$store.getters['character/drones/stats']
		},
		HP: {
			get: function() {
				return this.current.Points.Hit
			},
			set: function(value) {
				return this.$store.dispatch('character/drones/setHP',value)
			}
		},
		RP: {
			get: function() {
				return this.current.Points.Resolve
			},
			set: function(value) {
				return this.$store.dispatch('character/drones/setRP',value)
			}
		}
	},
}
</script>

<style scoped>

</style>